module.exports = __webpack_public_path__ + "static/img/logo_4.bfd39e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_4.png
// module id = yWUs
// module chunks = 7